import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardTitle,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import TeacherTable from "../../components/Tables/TeacherTable";
import StudentTable from "../../components/Tables/StudentTable";
import { fetchClass } from "../../actions/classActions";
import { fetchSchoolTeachers } from "../../actions/schoolActions";
import CreateTeacher from "../../components/Modal/CreateTeacherModal";
import AddTeachers from "../../components/Modal/AddTeachersToClass";
import AddStudents from "../../components/Modal/AddStudentsToClass";
import ImportStudentForm from "../../components/Forms/ImportStudentsForm";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import EditStudent from "../../components/Modal/EditStudent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

function ClassOverview(props) {
  const [teacherFilter, setTeacherFilter] = useState("");
  const [studentFilter, setStudentFilter] = useState("");
  const [allTeachers, setAllTeachers] = useState(props.location.state.teachers);
  const [teacherModal, setTeacherModal] = useState(false);
  const [studentModal, setStudentModal] = useState(false);
  const [imporStudentsModal, setImporStudentsModal] = useState(false);
  const [detachTeacherModal, setDetachTeacherModal] = useState(false);
  const [teacherToDetach, setTeacherToDetach] = useState({});
  const [teacherToUpdate, setTeacherToUpdate] = useState(null);
  const [createTeacherModal, setCreateTeacherModal] = useState(false);
  const [studentToUpdate, setStudentToUpdate] = useState(null);
  const [studentEditModal, setStudentEditModal] = useState(false);

  const classReducer = useSelector((state) => state.classReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClass(props.location.state.class.id));
  }, [props.location.state.class.id, dispatch]);

  if (classReducer.loadingSingleClass) {
    return <Pacmanloader />;
  }

  const toggleStudentEditModal = (student) => {
    setStudentToUpdate(null);
    if (student && student.hasOwnProperty("email")) {
      setStudentToUpdate(student);
    }
    setStudentEditModal(!studentEditModal);
  };

  const reloadClass = () => {
    dispatch(fetchClass(props.location.state.class.id));
  };

  const getallTeachers = () => {
    dispatch(fetchSchoolTeachers(props.location.state.schoolId)).then((res) => {
      setAllTeachers(props.schoolTeachers.result);
    });
  };

  const filterTeachers = (event) => {
    setTeacherFilter(event.target.value);
  };

  const toggleModals = (entity) => {
    if (entity === "teacher") {
      setTeacherModal(!teacherModal);
    } else if (entity === "studentImport") {
      setImporStudentsModal(!imporStudentsModal);
    } else {
      setStudentModal(!studentModal);
    }
  };

  const filterStudents = (event) => {
    setStudentFilter(event.target.value);
  };

  const toggleDetachTeacherModal = (teacher) => {
    setTeacherToDetach({ name: teacher.name, id: teacher.id });
    setDetachTeacherModal(true);
  };

  const toggleCreateTeacherModal = (teacher) => {
    setTeacherToUpdate(null);
    if (teacher) {
      getTeacher(teacher.id)
        .then((classes) => {
          teacher.classes = classes;
          setTeacherToUpdate(teacher);
          setCreateTeacherModal(!createTeacherModal);
          return;
        })
        .catch((err) => {
          setCreateTeacherModal(!createTeacherModal);
        });
    } else {
      setCreateTeacherModal(!createTeacherModal);
    }
  };

  const detachTeacher = () => {
    axios
      .post(
        `teacher/removefromclass?teacherid=${teacherToDetach.id}&classid=${classReducer.singleClass.id}`
      )
      .then(() => {
        toast.success(
          <FormattedMessage id="TheTeacherHasBeenRemovedFromTheClass" />,
          TOAST_CONFIG
        );
        reloadClass();
        resetDetachTeacher();
      })
      .catch((err) => {
        toast.warn(
          props.intl.formatMessage(
            { id: "CouldNotDeleteTeacherTeacherName" },
            {
              teacher: err.response.data,
            }
          ),
          TOAST_CONFIG
        );
        resetDetachTeacher();
      });
  };

  const getTeacher = (id) => {
    return new Promise((resolve, reject) => {
      if (id) {
        axios.get(`/Teacher/${id}`).then((res) => {
          resolve(res.data.result.classes);
        });
      } else {
        reject("unable to fetch teacher info.");
      }
    });
  };

  const resetDetachTeacher = () => {
    setDetachTeacherModal(false);
    setTeacherToDetach({});
  };

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">{classReducer.singleClass.name}</h5>
      </div>
      <Row>
        <Col sm="6">
          <Card body>
            <CardTitle>
              <FormattedMessage id="Teacher" />
            </CardTitle>
            <Row className="search-row">
              <Col className="col-6">
                <Input
                  className="search-input"
                  placeholder={props.intl.formatMessage({
                    id: "SearchTeacher",
                  })}
                  onChange={filterTeachers.bind(this)}
                />
              </Col>
              <Col className="offset-1 col-5">
                <Button
                  color="primary"
                  outline
                  className="float-end"
                  onClick={() => {
                    toggleModals("teacher");
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </Col>
            </Row>
            <TeacherTable
              updateTeacher={toggleCreateTeacherModal}
              detachTeacher={toggleDetachTeacherModal}
              teachers={classReducer.singleClass?.teachers || []}
              filter={teacherFilter}
              fullAccess={true}
            />
          </Card>
        </Col>
        <Col sm="6">
          <Card body>
            <CardTitle>
              <FormattedMessage id="Students" />
            </CardTitle>
            <Row className="search-row">
              <Col className="col-6">
                <Input
                  className="search-input"
                  placeholder={props.intl.formatMessage({
                    id: "SearchStudent",
                  })}
                  onChange={filterStudents.bind(this)}
                />
              </Col>
              <Col className="offset-1 col-5">
                <Button
                  color="primary"
                  outline
                  className="float-end"
                  onClick={() => toggleModals("studentImport")}
                >
                  <FontAwesomeIcon icon="upload" />{" "}
                  <FormattedMessage id="ImportStudents" />
                </Button>
              </Col>
            </Row>
            <StudentTable
              toggleEdit={toggleStudentEditModal}
              students={classReducer.singleClass?.students || []}
              filter={studentFilter}
            />
          </Card>
        </Col>
      </Row>

      <AddTeachers
        classId={classReducer.singleClass.id}
        isOpen={teacherModal}
        toggle={() => toggleModals("teacher")}
        teachers={allTeachers}
        existingTeachers={classReducer.singleClass.teachers}
        loadTeachers={reloadClass}
        reloadAllTeachers={getallTeachers}
      />

      <AddStudents
        classId={classReducer.singleClass.id}
        isOpen={studentModal}
        toggle={() => toggleModals("student")}
        students={props.location.state.students}
        loadStudents={reloadClass}
        existingStudents={classReducer.singleClass.students}
      />

      <EditStudent
        toggle={toggleStudentEditModal.bind(this)}
        isOpen={studentEditModal}
        student={studentToUpdate}
        updateStudents={reloadClass}
        classes={props.location.state.schoolClasses}
      />

      <ConfirmDialog
        isOpen={detachTeacherModal}
        title={props.intl.formatMessage({
          id: "RemoveTeacherFromClass",
        })}
        message={
          <div>
            {props.intl.formatMessage(
              { id: "AreYouSureYouWantToDeleteTeacherNameFromClassName" },
              {
                teacherName: teacherToDetach.name,
                className: classReducer.singleClass.name,
              }
            )}
          </div>
        }
        toggle={resetDetachTeacher}
        onProceed={detachTeacher}
        danger={true}
      />

      <Modal
        size="lg"
        isOpen={imporStudentsModal}
        toggle={() => toggleModals("studentImport")}
      >
        <ModalHeader toggle={() => toggleModals("studentImport")}>
          <FontAwesomeIcon icon="upload" />
          &nbsp; <FormattedMessage id="ImportStudents" />
        </ModalHeader>
        <ModalBody>
          <ImportStudentForm
            preSelectedClassId={classReducer.singleClass.id}
            updateStudents={reloadClass}
            dismissModal={() => toggleModals("studentImport")}
            studentClasses={[classReducer.singleClass]}
          />
        </ModalBody>
      </Modal>

      <CreateTeacher
        teacherToUpdate={teacherToUpdate}
        schoolClasses={props.location.state.schoolClasses}
        isOpen={createTeacherModal}
        toggle={toggleCreateTeacherModal}
        loadTeachers={reloadClass}
        fullAccess={true}
      />
    </div>
  );
}
export default injectIntl(ClassOverview);
